import { useAxesTooltip } from "@mui/x-charts/ChartsTooltip";
import { DateTime } from "luxon";

export type TooltipAxisValueFormatter = ((value: number) => string) | ((value: Date) => string);

type AxisTooltipData = NonNullable<ReturnType<typeof useAxesTooltip>>[number];

export const formatTooltipAxisValue = (tooltipData: AxisTooltipData, formatter?: TooltipAxisValueFormatter): string => {
  if (formatter) {
    return tooltipData.axisValue instanceof Date
      ? (formatter as (value: Date) => string)(tooltipData.axisValue)
      : (formatter as (value: number) => string)(tooltipData.axisValue as number);
  }
  return tooltipData.axisValue instanceof Date
    ? DateTime.fromJSDate(tooltipData.axisValue).toFormat("ccc MMMM d, yyyy")
    : tooltipData.axisFormattedValue;
};
